import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService } from "src/app/services/auth.service";

export interface TxDocument {
  internalUnicodeFormat: string;
  html: string;
  pdf: string;
}

@Component({
  selector: "app-txt-control-editior",
  templateUrl: "./txt-control-editor.component.html",
})
export class TxtControlEditorComponent implements OnInit {
  @ViewChild("editorIframe", { static: false })
  editorIframe!: ElementRef<HTMLIFrameElement>;
  @Input() public text: any;
  @Input() public html: any;
  @Input() public header: any;

  urlTxtEditor: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    const rawUrl = this.authService.getTxControlUrl();
    this.urlTxtEditor = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }

  onIframeLoad() {
    if (this.html) {
      this.editorIframe.nativeElement.contentWindow.postMessage(
        {
          type: "load-html",
          payload: this.html,
        },
        "*"
      );
    } else if (this.text) {
      this.editorIframe.nativeElement.contentWindow.postMessage(
        {
          type: "load-document",
          payload: this.text,
        },
        "*"
      );
    } else if (this.header) {
      this.editorIframe.nativeElement.contentWindow.postMessage(
        {
          type: "load-empty-document",
          payload: this.header,
        },
        "*"
      );
    } else {
      this.editorIframe.nativeElement.contentWindow.postMessage(
        {
          type: "load-empty-document",
          payload: "",
        },
        "*"
      );
    }
  }

  public addTemplate(
    result: string[],
    headerHtml: string,
    footerHtml: string
  ): void {
    this.editorIframe.nativeElement.contentWindow.postMessage(
      {
        type: "append-documents",
        payload: {
          templates: result,
          headerHtml: headerHtml,
          footerHtml: footerHtml,
        },
      },
      "*"
    );
  }

  async getDocument(
    headerHtml: string,
    footerHtml: string
  ): Promise<TxDocument> {
    const document = await this.getTxDocument(headerHtml, footerHtml);
    return document;
  }

  private getTxDocument(
    headerHtml: string,
    footerHtml: string
  ): Promise<TxDocument> {
    return new Promise((resolve) => {
      const handler = (event: MessageEvent) => {
        if (event.data.type === "get-document") {
          window.removeEventListener("message", handler); // limpiamos
          resolve(event.data.payload);
        }
      };
      window.addEventListener("message", handler);

      this.editorIframe.nativeElement.contentWindow.postMessage(
        {
          type: "get-document",
          payload: {
            headerHtml: headerHtml,
            footerHtml: footerHtml,
          },
        },
        "*"
      );
    });
  }
}
